export const iconFontAwesomeArrowsSortDown = (
	<i className="fa-solid fa-sort-down"></i>
);
